import { create } from 'zustand'
import { createJSONStorage, devtools, persist } from 'zustand/middleware'
import { Organization, Workspace, Company } from '../api/types'

interface SettingsStore {
  organization: Partial<Organization>
  active_workspace: Partial<Workspace>
  active_company: Partial<Company>
  setOrganization: (organization: Partial<Organization>) => void
  setActiveWorkspace: (workspace: Partial<Workspace>) => void
  setActiveCompany: (company: Partial<Company>) => void
  resetAll: () => void
  resetOrganization: () => void
  resetActiveWorkspace: () => void
  resetActiveCompany: () => void
}

export const useSettingsStore = create<SettingsStore>()(
  devtools(
    persist(
      set => ({
        organization: {},
        active_workspace: {},
        active_company: {},
        setOrganization: (organization: Partial<Organization>) =>
          set(old => ({
            ...old,
            organization: {
              ...old.organization,
              ...organization
            }
          })),
        setActiveWorkspace: (workspace: Partial<Workspace>) =>
          set(old => ({
            ...old,
            active_workspace: {
              ...old.active_workspace,
              ...workspace
            }
          })),
        setActiveCompany: (company: Partial<Company>) =>
          set(old => ({
            ...old,
            active_company: {
              ...old.active_company,
              ...company
            }
          })),
        resetAll: () =>
          set({
            organization: {},
            active_workspace: {},
            active_company: {}
          }),
        resetOrganization: () =>
          set(old => ({
            ...old,
            organization: {}
          })),
        resetActiveWorkspace: () =>
          set(old => ({
            ...old,
            active_workspace: {}
          })),
        resetActiveCompany: () =>
          set(old => ({
            ...old,
            active_company: {}
          }))
      }),
      {
        name: `organization`,
        storage: createJSONStorage(() => localStorage)
      }
    )
  )
)
